// extracted by mini-css-extract-plugin
export default {"ads__section":"style_ads__section__wIuNP","box":"style_box__NwZfq","box__text":"style_box__text__xfobB","box__img":"style_box__img__2wq2f"};